<template>
    <div>
        <b-overlay :show="loading">

            <form @submit.prevent="create" v-if="intent">
                <b-form-input v-model="form.name" id="card-holder-name" type="text" placeholder="Nome do Titular" class="mb-3"/>
                <div id="card-element" class="mb-3 form-control"></div>
         
                <button id="card-button" class="btn btn-block btn-primary" :data-secret="intent.client_secret">
                    Adicionar método de pagamento
                </button>
            </form>
        </b-overlay>
    </div>
</template>

<script>
import {loadStripe} from '@stripe/stripe-js';
export default {
    data () {
        return {
            stripe: null,
            cardElement: null,
            form: {
                name: null
            },
            intent: null,
            loading: false,
        }
    },

    async mounted (){
        this.loading = true
        axios.get('/teacher/subscription/payment-method/intent').then((result) => {
            this.intent = result.data.data.intent;

            this.mountCardElement(result.data.data.pk_stripe);
        }).catch((err) => {
            
        }).finally(() => this.loading = false);

    },

    methods: {
        async mountCardElement(stripeKey){
            const stripe = await loadStripe(stripeKey);
            const cardElement = stripe.elements().create('card', {style: { base: { fontSize:'16px'}}});

            cardElement.mount('#card-element')

            this.cardElement = cardElement;
            this.stripe = stripe;
        },

        async create(){
            const {setupIntent, error} = await this.stripe.confirmCardSetup(
                this.intent.client_secret, {
                    payment_method: {
                        card: this.cardElement,
                        billing_details: { name: this.form.name}
                    }
                }
            );

            if(error){
                this.$toast.error(error.message);
            }
            else {
                axios.post('/teacher/subscription/save-payment-method', {intent: setupIntent})
                .then((result) => {
                       window.location.reload();
                }).catch((err) => {
                    
                });
            }
        }
    }
}
</script>

<style>

</style>